import React from "react";

import {
  FaGlobe,
  FaFacebook,
  FaInstagram,
  FaLinkedin,
  FaYoutube,
  FaWhatsapp,
} from "react-icons/fa";

function CompanySocialLinks() {
  const socialLinks = [
    {
      name: "Website",
      icon: <FaGlobe />,
      url: "https://myresearchroom.com/",
      color: "bg-blue-600",
    },
    {
      name: "LinkedIn",
      icon: <FaLinkedin />,
      url: "https://in.linkedin.com/company/myresearchroomy",
      color: "bg-blue-700",
    },
    {
      name: "Facebook",
      icon: <FaFacebook />,
      url: "https://www.facebook.com/people/NeoWesolutize-Technology/61591065524869/",
      color: "bg-blue-500",
    },
    {
      name: "Instagram",
      icon: <FaInstagram />,
      url: "https://www.instagram.com/neowesolutize/",
      color: "bg-pink-500",
    },
    {
      name: "YouTube",
      icon: <FaYoutube />,
      url: "https://www.youtube.com/@WeSolutizeTechnologies",
      color: "bg-red-600",
    },
    {
      name: "WhatsApp",
      icon: <FaWhatsapp />,
      url: "https://wa.me/8767897950",
      color: "bg-green-600",
    },
  ];

  return (
    <div className="bg-white rounded-xl shadow-md p-6">
      <h2 className="text-xl font-semibold text-primary mb-5">
        Connect With Us
      </h2>

      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4">
        {socialLinks.map((item) => (
          <a
            key={item.name}
            href={item.url}
            target="_blank"
            rel="noopener noreferrer"
            className={`${item.color} text-white rounded-lg p-4 flex flex-col items-center justify-center gap-2 transition hover:scale-105`}
          >
            <span className="text-3xl">{item.icon}</span>
            <span className="text-sm font-medium">{item.name}</span>
          </a>
        ))}
      </div>
    </div>
  );
}

export default function ClientDashboard() {
  return (
    <section className="py-6 px-4">
      <div className="max-w-7xl mx-auto space-y-6 flex justify-center flex-col items-center">

        <div className="grid md:grid-cols-2 gap-5">
          <div className="bg-gradient-to-r from-blue-600 to-cyan-400 text-white rounded-xl p-6 shadow-lg max-w-5xl">
            <h1 className="text-2xl md:text-3xl font-bold mb-2">
              💐 Welcome to MRR PMS 💐
            </h1>

            <p className="text-sm md:text-base">
              This platform helps you manage your research projects, submit your project details, track project progress, and communicate with our
              research support team—all from one place.
            </p>

            <p className="mt-3 text-sm md:text-base">
              We wish you a productive and successful research journey!
            </p>
          </div>

          <CompanySocialLinks/>

        </div>

        <div className="bg-white rounded-xl shadow-md p-6 border border-gray-300">
          <h2 className="text-xl font-semibold text-primary mb-4">
            Getting Started with My Research Room PMS
          </h2>

          <div className="relative w-full overflow-hidden rounded-lg aspect-video">
            <iframe
              className="w-full h-full"
              src="https://www.youtube.com/embed/u3zF11GQmTY?si=xYlHxdz0ifp6y7B3" 
              title="MR PMS Introduction"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>

          <p className="mt-4 text-gray-600 text-sm md:text-base">
            Watch this short video to learn how to use MRR PMS to submit your project details, track project progress, and communicate with our research support team.
          </p>
        </div>  

      </div>
    </section>
  );
}